// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-item span[data-v-15f4db16],a.menu-item[data-v-15f4db16]{color:#fff;border-color:#fff;font-family:Roboto,sans-serif;font-size:16px;font-weight:400;line-height:44px}i[data-v-15f4db16]{color:#fff}.clickable[data-v-15f4db16]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
